module.exports = __webpack_public_path__ + "static/media/webdesign-services-img23.c38912e5.jpg";